import { TopNav } from '@widgets/TopNav';
import { useAppNavigationStore } from './navigationStore';
import { PreviewPage } from '@pages/Preview';
import { AvatarPage } from '@pages/Avatar';
import { StreamingPage } from '@pages/Streaming';
import { SettingsPage } from '@pages/Settings';
import { SpeedInsights } from "@vercel/speed-insights/react"
import { AuthModal } from '@widgets/AuthModal';

const PAGE_BY_TAB = {
  preview: PreviewPage,
  avatar: AvatarPage,
  streaming: StreamingPage,
  settings: SettingsPage,
} as const;

export function App() {
  const activeTab = useAppNavigationStore((state) => state.activeTab);
  const ActivePage = PAGE_BY_TAB[activeTab];

  return (
    <div className="flex h-dvh w-full flex-col overflow-hidden bg-surface-0">
      <TopNav />
      <main className="min-h-0 flex-1">
        <SpeedInsights/>
        <ActivePage />
      </main>
      <AuthModal />
    </div>
  );
}
